<template>
  <AuthLayout>
    <div class="mt-9">


      <template v-if="step === 'PHONE'">
        <div class="mb-6">
          <label class="form-label text-center">Votre Numéro de téléphone</label>
          <PhoneInput v-model="phone" container-class="h-12 border rounded-xl overflow-hidden flex" input-class="border-l h-full px-4 w-full flex-1 outline-none bg-neutral-50"/>
          <span class="text-red-600 pt-3 font-medium block" v-if="error">{{error}}</span>
        </div>
        <button class="btn-large bg-primary text-white w-full" @click="send" :disabled="loadingSend">
          <span v-if="loadingSend">Envoi en cours...</span>
          <span v-else>Recevoir un code par SMS</span>
        </button>
        <span class="text-neutral-500 text-center block mt-6">Vous allez recevoir un code unique de connexion par SMS</span>
      </template>


      <template v-if="step === 'PIN'">
        <div class="text-center flex items-center justify-center flex-col">
          <div class="mb-6">
            <label class="form-label">Code Unique</label>
            <PinCode v-model="code"/>
            <span class="text-red-600 pt-3 font-medium block" v-if="error">{{error}}</span>
          </div>
          <button class="btn-large bg-primary text-white w-full" @click="check" :disabled="loadingCheck">
            <span v-if="loadingCheck">Vérification...</span>
            <span v-else>Connexion</span>
          </button>
          <span class="text-neutral-500 text-center block mt-6">
            Vous n'avez rien reçu ? 
            <b v-if="canResend" @click="send" class="text-primary underline cursor-pointer">Renvoyer</b>
            <span v-else class="text-neutral-400">Renvoyer ({{ resendTimer }}s)</span>
          </span>
        </div>
      </template>




      <div class="-mx-8 mt-6">
        <button @click="$router.push('/login')" class="w-full border-t h-16  flex items-center justify-center gap-2 text-neutral-600"><i class="material-icons text-lg">arrow_back</i>Connexion avec mot de passe</button>
      </div>
    </div>
  </AuthLayout>
</template>

<script setup lang="ts">
import AuthLayout from "@/components/Layouts/AuthLayout.vue";
import PhoneInput from "@/components/Ui/Form/PhoneInput.vue";
import {ref} from "vue";
import PinCode from "@/components/Ui/Elements/PinCode.vue";
import {sendPhoneCode, checkAndLoginWithPhoneCode} from "@/services/AccountService";
import {getCurrentAccount} from "@/services/AccountService";
import {useStore} from "vuex";
import {useRouter} from "vue-router";

const store = useStore();

const step = ref<'PHONE' | 'PIN'>('PHONE');
const token = ref(null);
const phone = ref(null);
const code = ref(null);
const error = ref(null);
const router = useRouter();
const loadingSend = ref(false);
const loadingCheck = ref(false);
const resendTimer = ref(0);
const canResend = ref(true);

function startResendTimer() {
  canResend.value = false;
  resendTimer.value = 60;
  const interval = setInterval(() => {
    resendTimer.value--;
    if (resendTimer.value <= 0) {
      clearInterval(interval);
      canResend.value = true;
    }
  }, 1000);
}

async function send(){
  error.value = null;
  loadingSend.value = true;
  await sendPhoneCode(phone.value)
      .then((responseToken) => {
        token.value = responseToken;
        step.value = 'PIN';
        startResendTimer();
      })
      .catch((e) => {
        step.value = 'PHONE';
        error.value = e.response.data.message || 'Une erreur est survenue, veuillez réessayer plus tard';
      })
      .finally(() => {
        loadingSend.value = false;
      });
}

async function check(){
  error.value = null;
  loadingCheck.value = true;
  await checkAndLoginWithPhoneCode(token.value, code.value)
      .then(async () => {
        await getCurrentAccount()
            .then((data) => {
              store.commit('account/SET_ACCOUNT', data);
              store.dispatch('getMerchantsAction');
              if(store.getters.merchants[0]?.status === 'building'){
                router.push({ path: '/onboarding/' });
              }
              else{
                router.push({ path: '/' });
              }
            })
            .catch((e) => {
              localStorage.clear();
              location.href = '/login?error=not_merchant_account';
            })
      })
      .catch((e) => {
        error.value = 'Le code est incorrect ou expiré';
      })
      .finally(() => {
        loadingCheck.value = false;
      });
}

</script>
